import React from "react";
import "../../page_content.css";

const PersonaFest = () => {
  return (
    <div>
      <h1 className="title">MIT - Persona Fest</h1>
      <hr />

      <div className="page-content-gallery">
        <img
          src="/assets/images/MIT Persona Fest/persona_1.webp"
          alt="Award 1"
        />
        <img
          src="/assets/images/MIT Persona Fest/persona_2.webp"
          alt="Award 2"
        />
      </div>
      <p>
        Persona Fest is the most awaited techno cultural event organized by the
        MIT-ADT University every year. It is truly a cultural extravaganza which
        is getting humongous participation and overwhelming response from the
        students across the length and breadth of Maharashtra. Talented Students
        from the various colleges under the MIT-ADT University as well as the
        students from the prestigious Institutions and Universities of
        Maharashtra & outside Maharashtra have been participating in the
        wide-ranging events for the last three years with great optimism and
        enthusiasm. MANET NAVAL Show is the key attraction of the persona Fest.
        MANET cadets represent the NAVAL Show which familiarizes the on-board
        machinery and systems with operational and maintenance routine. This
        show also highlights the features of commissioned 360-degree bridge
        SIMULATOR which adds the learning features of seafarer activities.
      </p>
      <div id="page-links">
        <p>For More Information</p>
        <button
          onClick={() =>
            window.open(
              "https://www.mitpersonafest.mituniversity.ac.in/",
              "_blank",
            )
          }
        >
          Click Here
        </button>
      </div>
    </div>
  );
};

export default PersonaFest;
